
































































































































































































































































































































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import DateFormat from '@/shared/utils/date-format';
import CustomerService from '@/domain/customer/service/customer.service';
import { VMoney } from 'v-money';
import Customer from '@/domain/customer/entity/customer.entity';
import ContractService from '@/domain/contract/service/contract.service';
import MainButton from '@/shared/buttons/main-button.component.vue';
import SearchCustomerComponent from '@/shared/search/customer-search.component.vue';
import ProductSearchComponent from '@/shared/search/product-search.component.vue';
import SearchByValueComponent from '@/shared/search/search-by-value.component.vue';
import SearchAllCustomerComponent from '@/shared/search/search-all-customer.component.vue';
import { BillingStatus as BillingStatusFilter } from '@/domain/billing/entity/billing-status.enum';
import Pagination from '../../../domain/pagination.entity';
import BillingStatus from './billing-status.json';
import NetValueOperators from './net-value-operator.json';
import DiscountedValueOperators from './discounted-value-operator.json';
import BillingFilter from '../../../domain/billing/entity/billing-filter.entity';
import BusinessUnitService from '../../../domain/business-unit/service/business-unit.service';
import ResultCenter from '../../../domain/business-unit/entity/result-center.entity';
import customerOptions from './customer-options.json';
import frequencyOptions from './frequency-options.json';

@Component({
  components: {
    MainButton,
    SearchCustomerComponent,
    SearchByValueComponent,
    ProductSearchComponent,
    SearchAllCustomerComponent,
  },
  directives: { money: VMoney },
})
export default class FilterComponent extends Vue {
  @Prop({
    required: false,
    default: false,
  })
  private showFilter!: boolean;

  @Prop({
    required: true,
    default: '',
  })
  private businessUnitId!: string;

  @Prop({
    required: false,
    default: BillingFilter.of({}),
  })
  private incomingFilter?: BillingFilter;

  @Prop({
    required: false,
    default: false,
  })
  private isAdministrator!: boolean;

  locale = 'pt-BR';

  customers: Array<Customer> = [];

  beneficiaries: Array<Customer> = [];

  products: Array<String> = [];

  customerFetch: string = '';

  filter: BillingFilter = new BillingFilter({});

  status = BillingStatus;

  netValueOperators = NetValueOperators;

  discountedValueOperators = DiscountedValueOperators;

  ref: any = this.$refs;

  selectedCompetenceDate: string = '';

  selectedPaymentDueAtDate: string = '';

  lastFilteredName: string = '';

  netValueKey: number = 0;

  discountedValueKey: number = 0;

  selectedDate: Array<string> = [];

  resultCenters: Array<ResultCenter> = [];

  lastFilteredBeneficiary = '';

  lastFilteredProduct = '';

  frequencyOptions = frequencyOptions;

  money: object = {
    decimal: ',',
    thousands: '.',
    precision: 2,
    prefix: '$ ',
    masked: false,
    max: 9999.99,
    min: 0.01,
  };

  pagination: Pagination = new Pagination({
    page: 0,
    itemsPerPage: 100,
    defaultSort: 'name|asc',
  });

  customerOptions = customerOptions;

  loadingResultCenters: boolean = false;

  updateFilterField(field: string, value: string) {
    this.filter[field] = value;
  }

  @Watch('incomingFilter')
  updateFilter() {
    if (this.incomingFilter && this.incomingFilter.competence) {
      this.selectedCompetenceDate = DateFormat.localToDate(this.incomingFilter.competence);
    }
  }

  clear() {
    this.ref.form.reset();
    this.filter = new BillingFilter({});
    this.netValueKey += 1;
    this.discountedValueKey += 1;
    this.selectedCompetenceDate = '';
    this.selectedPaymentDueAtDate = '';
    this.selectedDate = [];
    this.send()
  }

  private formatDate(dates: Array<string>): Array<string> {
    if (dates && dates.length === 2) {
      return dates.map((el: string) => DateFormat.timestampToLocal(el));
    }
    return [];
  }

  get dateRangeText() {
    return this.formatDate(this.selectedDate).join(' ~ ');
  }

  send() {
    if (this.selectedCompetenceDate) {
      this.filter.competence = DateFormat.localDateToLocal(this.selectedCompetenceDate);
    }
    if (this.selectedDate.length !== 0) {
      this.filter.dueDateStart = DateFormat.timestampToLocal(this.selectedDate[0]);
      this.filter.dueDateEnd = DateFormat.timestampToLocal(this.selectedDate[1]);
    }
    this.$emit('filter', this.filter);
  }

  sendRemoveAllSelected() {
    this.$emit('removeAllSelected');
  }

  get competenceDateText() {
    return DateFormat.fullMonthAndYear(DateFormat.localDateToLocal(this.selectedCompetenceDate));
  }

  get paymentDueAtDateText() {
    return DateFormat.timestampToLocal(this.selectedPaymentDueAtDate);
  }

  checkAndApplyUrlFilter(): void {
    let { status } = this.$route.params;
    if (status || this.$route.params.competence) {
      if (status === BillingStatusFilter.DISCOUNTED) {
        status = BillingStatusFilter.BILLED;
        this.filter.discountedValueOperator = 'GREATER_THAN';
        this.filter.discountedValue = '0.01';
      }
      if (status && (status.toUpperCase() === BillingStatusFilter.INVOICE_ZERO_VALUE)) {
        status = BillingStatusFilter.PRE_INVOICE;
        this.filter.netValueOperator = 'EQUAL';
        this.filter.netValue = '0.00';
      }
      if (status && (status.toUpperCase() === BillingStatusFilter.INVOICE_HAS_VALUE)) {
        status = BillingStatusFilter.PRE_INVOICE;
        this.filter.netValueOperator = 'GREATER_THAN';
        this.filter.netValue = '0.01';
      }
      this.filter.status = status;
      this.filter.competence = DateFormat.localDateToLocal(this.$route.params.competence);
      this.selectedCompetenceDate = this.$route.params.competence;
    }

    const contractId: number = +this.$route.query.contractId;
    if (contractId) {
      this.filter.contractExternalId = contractId;
    }
  }

  created() {
    this.checkAndApplyUrlFilter();
    this.getCustomers(this.customerFetch);
    this.getResultCenters();
  }

  selectAllCustomers(clicked: boolean) {
    this.filter.customerIds = clicked ? this.customers.map((customer) => customer.id) : [];
  }

  getCustomers(name: string) {
    if (name && name.length >= 3 && name !== this.lastFilteredName) {
      this.lastFilteredName = name;
      CustomerService.getByTradingNameOrNameOrDocument(
        this.pagination,
        name,
        this.filter.selectedCustomerOption,
        this.businessUnitId,
      )
        .then((response: any) => {
          this.customers = Customer.ofList(response.content)
        });
    }
  }

  updated() {
    if (this.resultCenters.length === 0) {
      this.getResultCenters()
    }
  }

  @Watch('businessUnitId')
  getResultCenters() {
    if (this.loadingResultCenters || !this.businessUnitId) return;
    this.loadingResultCenters = true;
    BusinessUnitService.getResultCenters(this.businessUnitId)
      .then((response) => this.resultCenters = response)
      .finally(() => this.loadingResultCenters = false);
  }

  get updateFilterFieldLabel() {
    const label = this.customerItemText;
    if (label === 'document') return 'CPF/CNPJ';
    return 'Nome do Cliente'
  }

  get customerItemText() {
    if (this.filter.isTradingNameFetch) return 'tradingName';
    if (this.filter.isDocumentFetch) return 'document';
    return 'name';
  }

  get beneficiaryItemText() {
    return this.filter.isBeneficiaryTradingNameFetch
      ? 'tradingName' : 'name';
  }

  getBeneficiaries(name: string) {
    if (name && name.length >= 3 && name !== this.lastFilteredBeneficiary) {
      this.lastFilteredBeneficiary = name;
      CustomerService.getByTradingNameOrName(this.pagination, name,
        this.filter.selectedBeneficiaryOption, '')
        .then((response: any) => {
          this.beneficiaries = Customer.ofList(response.content)
        });
    }
  }

  getProducts(name: string) {
    if (name && name.length >= 3 && name !== this.lastFilteredProduct) {
      this.lastFilteredProduct = name;
      ContractService.getProductDescriptions(this.pagination, this.businessUnitId, name)
        .then((response: any) => {
          this.products = response.content;
        });
    }
  }
}
